@if (bucketInfo(); as bucketInfo) {
  <app-dynamic-controls [bucketType]="bucketInfo.BucketType" [initialValue]="initialValue" [readOnly]="readOnly" (controlValues)="selectedTags($event)">
  </app-dynamic-controls>
}

